<template>
  <div>
    <div class="recorder" v-if="browserMessage === null">
      <h2 class="optionTitle">{{ $t('recorder.heading') }}</h2>
      <!-- Only one of the buttons is rendered at a time -->
      <!-- Aufnahme Starten -->
      <button
        v-if="state == 'disabled' || state == 'enabled'"
        class="recorderButton activated"
        @click="startRecording"
      >
        <template v-if="!hasRecord">{{
          $t('recorder.startRecording')
        }}</template>
        <template v-else>{{ 'Neue Aufnahme Starten' }}</template>
      </button>
      <!-- Aufnahme Stoppen -->
      <button
        v-if="state == 'recording'"
        class="recorderButton recording"
        @click="stopRecording"
      >
        <span style="float: left">{{ $t('recorder.stopRecording') }}</span>
        <span style="float: right">{{ minutes }}:{{ seconds }}</span>
      </button>
      <div v-if="recordingError" class="errorText">
        {{ recordingError }}
      </div>
    </div>
    <div v-else>
      <p class="browserNotWorkingMessage">{{ this.browserMessage }}</p>
      <p>Bitte probiere es mit einem anderen Browser</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Bowser from 'bowser'
import RecorderService from '../../util/RecorderService'
import { isBelowMaxFileSize } from '../../provider/smosterProvider'
import { trackProblemEvent } from '../../util/tracker'
import { store } from '../../store/store'

export default {
  name: 'Recorder',
  props: {
    p5container: Object,
  },
  data: function() {
    return {
      recordingStartTimestamp: null,
      currentTimestamp: null,
      soundFile: null,
      p5SoundFile: null,
      state: 'disabled', // Three different states: disabled | enabled | recording
      recorderInterval: null,
      streamIsReadyInterval: null,
      soundLoadedCheckInterval: null,
      browserMessage: null,
      userOS: null,
      recorderService: null,
      recordingUrl: null,
      recordingError: null,
    }
  },
  computed: {
    seconds() {
      const secondsPassed =
        (this.currentTimestamp - this.recordingStartTimestamp) % 60
      // add leading zero
      return secondsPassed < 10 ? '0' + secondsPassed : secondsPassed
    },
    minutes() {
      return (
        Math.trunc(
          (this.currentTimestamp - this.recordingStartTimestamp) / 60
        ) % 60
      )
    },
    hasRecord() {
      return this.recordingUrl !== null
    },
  },
  created() {
    this.recorderService = new RecorderService()
    this.recorderService.em.addEventListener('recording', (evt) =>
      this.onNewRecording(evt)
    )
  },
  mounted: function() {
    const browser = Bowser.getParser(window.navigator.userAgent)
    this.isIOS = browser.getOSName() === 'iOS'
    this.isSafari = browser.getBrowser().name === 'Safari'

    if (!Modernizr.getusermedia) {
      trackProblemEvent('Recorder', 'BrowserNotSupported')
      this.browserMessage =
        'Leider ist die Aufnahme mit diesem Browser nicht möglich.'
    }
  },
  methods: {
    startRecording: function() {
      this.recorderService.startRecording().then((result) => {
        if (result) {
          this.recordingStartTimestamp = Math.trunc(new Date().getTime() / 1000)
          this.currentTimestamp = Math.trunc(new Date().getTime() / 1000)
          this.recorderInterval = setInterval(this.updateTimePassed, 1000)
          this.state = 'recording'
        } else {
          trackProblemEvent('Recorder', 'RecordingStartFailed')

          if (this.isIOS) {
            this.browserMessage =
              'Leider kann die Webseite nicht auf das Mikrofon zugreifen'
          }
        }
      })
    },
    stopRecording: function() {
      this.recorderService.stopRecording()
      clearInterval(this.recorderInterval)
      this.state = 'enabled'
    },
    onNewRecording(event) {
      const recording = event.detail.recording
      this.recordingUrl = recording.blobUrl

      const file = new File([recording.blob], 'recording.wav', {
        type: 'audio/wav',
      })
      this.soundFile = file

      if (isBelowMaxFileSize(this.soundFile)) {
        this.recordingError = null
        this.p5SoundFile = this.p5container.loadSound(file)
        this.soundLoadedCheckInterval = setInterval(
          this.checkP5SoundFileLoaded,
          500
        )
      } else {
        trackProblemEvent('Recorder', 'FileSizeTooBig')
        this.recordingError =
          'Die Aufnahme ist zu lang. Aktuell sind leider nur Aufnahmen von einer Minute möglich'
      }
    },
    updateTimePassed: function() {
      this.currentTimestamp = Math.trunc(new Date().getTime() / 1000)
    },
    checkP5SoundFileLoaded: function() {
      if (this.p5SoundFile.isLoaded()) {
        clearInterval(this.soundLoadedCheckInterval)

        store.dispatch('uploadAudio', {
          file: this.soundFile,
          type: 'RECORDING',
        })

        this.$emit('audioAvailable', {
          p5soundFile: this.p5SoundFile,
          audioUrl: this.recordingUrl,
          isRecording: true,
        })
      }
    },
  },
}
</script>
